import axios from 'axios';

const BaseUrl = process.env.REACT_APP_Server_BASE;

export const getTimeToken = async (gameId = "quiz", timeType = "progress") => {
  try {
    const currentTimeInSeconds = Math.floor(new Date().getTime() / 1000);
    const response = await axios.post(`${BaseUrl}/api/time/check`, {
      game_id: gameId,
      time_type: timeType,
      time: currentTimeInSeconds
    });
    
    return {
      token: response.data.token,
      timestamp: currentTimeInSeconds
    };
  } catch (error) {
    console.error('خطا در دریافت توکن زمانی:', error);
    throw error;
  }
};